import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { ParametrageModule } from '../parametrage/parametrage.module';
import { ListTypeFormationComponent } from './list-typeFormation/list-typeFormation.component';
import { TypeFormationModalAjoutComponent } from './modal/typeFormation-modal-ajout/typeFormation-modal-ajout.component';
import { TypeFormationModalDetailComponent } from './modal/typeFormation-modal-detail/typeFormation-modal-detail.component';
import { FilterTypeFormationByNamePipe } from 'src/app/shared/pipes/filter-typeFormation-by-name/filter-typeFormation-by-name.pipe';

@NgModule({
	declarations: [
		ListTypeFormationComponent,
		TypeFormationModalDetailComponent,
		TypeFormationModalAjoutComponent
	],
	imports: [SharedModule, ParametrageModule],
	providers: [FilterTypeFormationByNamePipe]
})

export class TypeFormationModule {}
